export const ROLE_LABEL = {
  admin: "Admin",
  president: "President",
  vice_president: "Vice President",
  social_chair: "Social Chairman",
  rush_chair: "Rush Chairman",
  chaplain: "Chaplain",
  philanthropy_chair: "Philanthropy Chair",
  scholarship_chair: "Scholarship Chairman",
  treasurer: "Treasurer",
  alumni_chair: "Alumni Chairman",
  marshal: "Marshal",
  risk_chair: "Risk Chairman",
  recorder: "Recorder",
  member: "Member",
  candidate: "Candidate",
  alumni: "Alumni",
};

export const ROLE_BADGE = {
  admin: "bg-purple-950/80 text-purple-300 border-purple-500",
  president: "bg-amber-950/80 text-amber-300 border-amber-500/60",
  vice_president: "bg-slate-800/90 text-slate-200 border-slate-500",
  social_chair: "bg-rose-950/80 text-rose-300 border-rose-600/60",
  rush_chair: "bg-amber-900/70 text-amber-300 border-amber-600",
  chaplain: "bg-blue-950/80 text-blue-300 border-blue-600",
  philanthropy_chair: "bg-emerald-950/80 text-emerald-300 border-emerald-600",
  scholarship_chair: "bg-cyan-950/80 text-cyan-300 border-cyan-600",
  treasurer: "bg-lime-950/80 text-lime-300 border-lime-600",
  alumni_chair: "bg-indigo-900/80 text-indigo-200 border-indigo-500",
  marshal: "bg-orange-950/80 text-orange-300 border-orange-600",
  risk_chair: "bg-red-950/80 text-red-300 border-red-600",
  recorder: "bg-neutral-800 text-neutral-200 border-neutral-500",
  member: "bg-slate-900 text-slate-400 border-slate-700",
  candidate: "bg-stone-900 text-stone-300 border-stone-600",
  alumni: "bg-indigo-950/70 text-indigo-300 border-indigo-700",
};

export const ALL_ROLES = Object.keys(ROLE_LABEL).filter(r => r !== "admin");

const PALETTE = [
  "#BE123C", "#D97706", "#EA580C", "#7C3AED", "#DB2777", "#0F172A", "#C026D3",
  "#2563EB", "#881337", "#059669", "#0D9488", "#F59E0B", "#1E3A8A", "#431407",
  "#65A30D", "#0891B2", "#38BDF8", "#7C3AED", "#0284C7", "#DC2626", "#9333EA",
];

const DEFAULT_CATS = [
  ...["Party", "Darty", "Tailgate", "Special Gathering", "Mixer", "Formal", "Date Party/Semi-Formal"]
    .map(n => ({ name: n, direct_roles: ["social_chair"], approval_roles: ["president", "vice_president", "recorder"], approvers: ["social_chair"], hidden_roles: [], prompts: { forms: true, location: true, times: true } })),
  { name: "Rush Event", direct_roles: ["rush_chair"], approval_roles: ["president", "vice_president", "recorder"], approvers: ["rush_chair"], hidden_roles: [], prompts: { forms: true, location: true, times: true } },
  { name: "Brotherhood Events", direct_roles: ["chaplain"], approval_roles: ["president", "vice_president", "recorder"], approvers: ["chaplain"], hidden_roles: [], prompts: { forms: true, location: true, times: true } },
  { name: "Brothers Only", direct_roles: ["chaplain"], approval_roles: ["president", "vice_president", "recorder"], approvers: ["chaplain"], hidden_roles: ["candidate"], prompts: { forms: true, location: true, times: true } },
  { name: "Philanthropy", direct_roles: ["philanthropy_chair"], approval_roles: ["president", "vice_president", "recorder"], approvers: ["philanthropy_chair"], hidden_roles: [], prompts: { forms: true, location: true, times: true } },
  { name: "Community Service", direct_roles: ["philanthropy_chair"], approval_roles: ["president", "vice_president", "recorder"], approvers: ["philanthropy_chair"], hidden_roles: [], prompts: { forms: true, location: true, times: true } },
  { name: "Payment Plan", direct_roles: ["treasurer"], approval_roles: ["president", "vice_president", "recorder"], approvers: ["treasurer"], hidden_roles: [], prompts: { forms: true, location: true, times: true } },
  { name: "Grade Check", direct_roles: ["scholarship_chair"], approval_roles: ["president", "vice_president", "recorder"], approvers: ["scholarship_chair"], hidden_roles: [], prompts: { forms: true, location: true, times: true } },
  { name: "Study Hours", direct_roles: ["scholarship_chair"], approval_roles: ["president", "vice_president", "recorder"], approvers: ["scholarship_chair"], hidden_roles: [], prompts: { forms: true, location: true, times: true } },
  { name: "Alumni Event", direct_roles: ["alumni_chair"], approval_roles: ["president", "vice_president", "recorder"], approvers: ["alumni_chair"], hidden_roles: [], prompts: { forms: true, location: true, times: true } },
  { name: "Risk Management Event", direct_roles: ["risk_chair", "social_chair"], approval_roles: ["president", "vice_president", "recorder"], approvers: ["risk_chair", "social_chair"], hidden_roles: [], prompts: { forms: true, location: true, times: true } },
  { name: "Chapter", direct_roles: ["president", "vice_president"], approval_roles: ["recorder"], approvers: ["president"], hidden_roles: [], prompts: { forms: true, location: true, times: true } },
  { name: "Initiation", direct_roles: ["president", "vice_president"], approval_roles: ["recorder"], approvers: ["president"], hidden_roles: ["candidate"], prompts: { forms: true, location: true, times: true } },
  { name: "Candidate Event", direct_roles: ["marshal"], approval_roles: ["president", "vice_president", "recorder"], approvers: ["marshal"], hidden_roles: [], anyone: true, prompts: { forms: true, location: true, times: true } },
];

let CATS = DEFAULT_CATS;

export const EVENT_TYPES = DEFAULT_CATS.map(c => c.name);
export const HIDDEN_FROM_CANDIDATES = DEFAULT_CATS.filter(c => (c.hidden_roles || []).includes("candidate")).map(c => c.name);

const EXTRA_COLORS = {};
DEFAULT_CATS.forEach((c, i) => { EXTRA_COLORS[c.name] = PALETTE[i % PALETTE.length]; });

export const EVENT_COLORS = new Proxy({}, {
  get: (_, name) => {
    const dot = EXTRA_COLORS[name] || "#888888";
    return { chip: "text-white border", dot, style: { background: dot + "33", borderColor: dot, color: dot } };
  },
});

export function setCategories(list) {
  CATS = list && list.length ? list : DEFAULT_CATS;
  EVENT_TYPES.length = 0;
  EVENT_TYPES.push(...CATS.map(c => c.name));
  HIDDEN_FROM_CANDIDATES.length = 0;
  HIDDEN_FROM_CANDIDATES.push(...CATS.filter(c => (c.hidden_roles || []).includes("candidate")).map(c => c.name));
  CATS.forEach((c, i) => { if (!EXTRA_COLORS[c.name]) EXTRA_COLORS[c.name] = PALETTE[(Object.keys(EXTRA_COLORS).length + i) % PALETTE.length]; });
}

export const getCategories = () => CATS;
export const getCategory = (name) => CATS.find(c => c.name === name);

export function visibleTypesForRole(role) {
  return CATS.filter(c => !(c.hidden_roles || []).includes(role)).map(c => c.name);
}

export const APPROVER_FOR_TYPE = new Proxy({}, { get: (_, name) => (getCategory(name)?.approvers || [])[0] });

const EXEC = ["admin", "president", "vice_president"];

export function effectiveRoles(user) {
  return [user.role, ...(user.roles || [])];
}

export function canCreateType(roles, type) {
  const cat = getCategory(type);
  if (!cat) return false;
  if (roles.some(r => EXEC.includes(r))) return true;
  if (cat.anyone) return true;
  return (cat.direct_roles || []).some(r => roles.includes(r)) || (cat.approval_roles || []).some(r => roles.includes(r));
}

export function willNeedApproval(roles, type) {
  const cat = getCategory(type);
  if (!cat) return false;
  if (roles.includes("admin")) return false;
  if ((cat.direct_roles || []).some(r => roles.includes(r))) return false;
  if (cat.anyone) return !(cat.approvers || []).some(r => roles.includes(r));
  return (cat.approval_roles || []).some(r => roles.includes(r));
}

export function canApproveType(roles, type) {
  const cat = getCategory(type);
  if (!cat) return false;
  if (roles.includes("admin")) return true;
  return (cat.approvers || []).some(r => roles.includes(r));
}

export function canEditEvent(user, event) {
  const roles = effectiveRoles(user);
  if (roles.includes("admin") || roles.includes("president")) return true;
  if (event.created_by === user.id) return true;
  return canApproveType(roles, event.event_type);
}

export function canManageRoster(roles) {
  return roles.includes("admin") || roles.includes("president");
}

export function allowedTypesForRole(roles) {
  return EVENT_TYPES.filter(t => canCreateType(roles, t));
}

export function isOfficer(roles) {
  return roles.some(r => !["member", "candidate", "alumni"].includes(r));
}
